<template>
  <!-- 本组件为：符合element-ui风格的三段式柱状图，如警告页里的柱状图 -->
  <div :class="className" :style="{height:height,width:width}" />
</template>

<script>
import echarts from 'echarts'
require('echarts/theme/macarons') // echarts theme
import resize from './resize'
import { getDateAndHour } from '@/utils/updateTime.js'
import i18n from '@/i18n'

const animationDuration = 2000

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '300px'
    },
    barData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      chart: null,
      xAxisData: [],
      seriesData1: [],
      seriesData2: [],
      seriesData3: [],
      legendData: []
    }
  },
  watch: {
    barData: {
      handler(newValue, oldValue) {
        this.barData = newValue // 把新值赋值给我们的属性数据
        this.initChart() // 刷新echarts图表
      },
      deep: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart() {
      this.xAxisData = []
      this.seriesData1 = []
      this.seriesData2 = []
      this.seriesData3 = []
      this.barData.forEach(v => {
        this.xAxisData.push(getDateAndHour(v.stime, 'onlyMonthAndDay'))
        this.seriesData1.push(v.remainCount) // 总剩余
        this.seriesData2.push(v.addCount) // 当日新增
        this.seriesData3.push(v.clearCount) // 当日解决
      })
      // console.log(this.barData)
      // this.legendData = ['总剩余', '当日新增', '当日解决']
      this.legendData = [i18n.t('warningPage.Remain'), i18n.t('warningPage.AddedToday'), i18n.t('warningPage.SolvedToday')]
      this.chart = echarts.init(this.$el, 'macarons')

      this.chart.setOption({
        // 用formatter回调函数显示多项数据内容
        tooltip: {
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          },
          formatter: function(params, ticket, callback) {
            // console.log('params----', params)
            var sortParam = [] // 颠倒顺序，使提示框文字的顺序相反
            sortParam.push(params[2])
            sortParam.push(params[1])
            sortParam.push(params[0])
            // console.log('sortParam------', sortParam)
            var htmlStr = ''
            // for (var j = 0; j < params.length; j++) {
            for (var j = 0; j < sortParam.length; j++) {
              var param = sortParam[j]
              // 隐藏某一类型时,param为undefined
              var xName = param ? param.name : ''// x轴的名称
              var seriesName = param ? param.seriesName : ''// 图例名称
              var value = param ? param.value : ''// y轴值
              var color = param ? param.color : ''// 图例颜色

              if (j === 0) {
                htmlStr += xName + '<br/>'// x轴的名称
              }
              htmlStr += '<div>'
              // 圆点
              htmlStr += '<span style="margin-right:5px;display:inline-block;width:10px;height:10px;border-radius:5px;background-color:' + color + ';"></span>'
              if (param) {
                // 圆点后面显示的文本
                htmlStr += seriesName + '：' + value
              }

              htmlStr += '</div>'
            }
            return htmlStr
          }
        },
        legend: {
          data: this.legendData
        },
        grid: {
          top: 50,
          left: '2%',
          right: '2%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [{
          type: 'category',
          // data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
          data: this.xAxisData,
          axisTick: {
            alignWithLabel: true
          }
        }],
        yAxis: [{
          type: 'value',
          axisTick: {
            show: false
          },
          minInterval: 1
        }],
        series: [
          {
            name: i18n.t('warningPage.SolvedToday'), // 当日解决
            type: 'bar',
            stack: 'vistors',
            barWidth: '40%',
            barMaxWidth: '30',
            // data: [30, 52, 200, 334, 390, 330, 220],
            data: this.seriesData3,
            color: '#8c98b3',
            animationDuration
          }, {
            name: i18n.t('warningPage.AddedToday'), // 当日新增
            type: 'bar',
            stack: 'vistors',
            barWidth: '40%',
            barMaxWidth: '30',
            // data: [80, 52, 200, 334, 390, 330, 220],
            data: this.seriesData2,
            color: '#b6a2de',
            animationDuration
          }, {
            name: i18n.t('warningPage.Remain'), // 总剩余
            type: 'bar',
            stack: 'vistors',
            barWidth: '40%',
            barMaxWidth: '30',
            // data: [79, 52, 200, 334, 390, 330, 220],
            data: this.seriesData1,
            color: '#59b1ef',
            animationDuration
          }]
      })
    }
  }
}
</script>
